import { getDeviceInfo } from '@moniebook-web/utils';
import { type PropsWithChildren, useMemo } from 'react';
import { ChromeOnly } from './chrome-only';
import { DesktopOnly } from './desktop-only';

export function UnsupportedDeviceBlocker({
    children,
}: Readonly<PropsWithChildren>) {
    const { isMobileBrowser, browser } = useMemo(() => {
        return getDeviceInfo();
    }, []);

    if (isMobileBrowser) {
        return <DesktopOnly />;
    } else if (!browser.name.includes('Chrome')) {
        return <ChromeOnly />;
    }

    return children;
}
